import {
  ArrowRigth,
  NavigateArrowLeft,
  NavigateArrowRigth,
} from '../../assets/svgs/icons'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'
import { PrimaryButton, SecondaryButton } from '../'

export const FooterNaviBar = ({ back, next, width }) => {
  const { t } = useTranslation()
  const large = width ? width : '100%'

  return (
    <div
      className={styles.container_nav_bar}
      style={{
        width: large,
      }}
    >
      <div className={styles.box_nav_bar}>
        <SecondaryButton onClick={back} size="medium">
          <NavigateArrowLeft color={'#190027'} />
          {t('fotter_bar.back')}
        </SecondaryButton>
        <PrimaryButton onClick={next} size="medium">
          {t('fotter_bar.next')}
          <NavigateArrowRigth color={'#ffffff'} />
        </PrimaryButton>
      </div>
    </div>
  )
}
